import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const ExecuteIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M11.9809 7.29156C12.8919 7.79922 12.8952 8.43784 11.9809 9.01179L4.91621 13.7764C4.02855 14.2501 3.42567 13.9704 3.36239 12.9454L3.33241 2.97321C3.31242 2.02903 4.09017 1.76227 4.83128 2.21496L11.9809 7.29156Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </BaseIcon>
  );
};

ExecuteIcon.displayName = 'ExecuteIcon';
